export default {
  goBackProfile: 'Профиль',
  download: 'Скачать договор',
  changes: 'Изменения от {lastModified}',
  sign: 'Согласовать договор',
  send: 'Отправить',
  correct: 'Внести корректировки',
  cancel: 'Отменить',
  yourComment: 'Комментарий',
  contactManager: 'Связаться с менеджером',
  commentSent: 'Комментарий успешно отправлен 👍'
}
